import { integrationSlice } from './slice'

export const {
  // ALL INTEGRATIONS
  setMyIntegrationLoading,
  setMyIntegrationResponse,
  setMyIntegrationError,

  // Create Integration
  setCreateIntegrationLoading,
  setCreateIntegrationSuccess,
  setCreateIntegrationError,
  resetCreateIntegrationState,

  // User Integrations
  setUserIntegrationListLoading,
  setUserIntegrationListData,
  setUserIntegrationListError,
  setMainChartDataLoading,
  setMainChartData,
  setIntegrationChartLoading,
  setIntegrationChartData,
  setUserIntegrationsFiltered,

  // Integration Purchases
  setIntegrationPurchasesListLoading,
  setIntegrationPurchasesListError,
  setIntegrationPurchasesList,
  setIntegrationPurchasesFiltered,

  // Integration Statics
  setIntegrationStaticsLoading,
  setIntegrationStaticsData,
  resetIntegrationStaticsState,

  // Integration WhiteLabel Reducers
  setWhiteLabelDetailsLoading,
  setWhiteLabelDetailsData,
  resetWhiteLabelDetails,

  // Integration Projects
  setIntegrationProjectsListLoading,
  setIntegrationProjectsListError,
  setIntegrationProjectsList,

  // Integration To Share Projects Reducers
  setIntegrationToShareProjectsListLoading,
  setIntegrationToShareProjectsListError,
  setIntegrationToShareProjectsListData,
  setIntegrationToShareProjectsListProjectId,
  setIntegrationToShareProjectsListFlag,

  // Deactivate Integration Reducers
  setDeactivateIntegrationLoading,
  setDeactivateIntegrationError,

  /* Reactivate Integration Reducers */
  setReactivateIntegrationLoading,
  setReactivateIntegrationError,
  setReactivateIntegrationSuccess,
  resetReactivateIntegrationState,

  /* Update Logo Reducers */
  setUpdateLogoLoading,
  setUpdateLogoSuccess,
  resetUpdateLogoState,

  /* Offset By Excel Reducers */
  setOffsetByExcelStep,
  resetOffsetByExcelState,
  setOffsetByExcelKeysAndExcelData,
  resetOffsetByExcelKeysAndExcelData,
  setOffsetByExcelKeysSelected,
  setPreparePurchasesLoading,
  setPreparePurchasesData,
  setSelectedProjectForPurchase,
  setSelectedVintagetForPurchase,
  setOffsetPurchasesLoading,
  setOffsetPurchasesHasFinished,
  setOffsetPurchasesPurchasesResults,
  setOffsetPurchasesFailedResults,
  resetOffsetPurchases,
  setOffsetOptionalFields,
  setOffsetOptionalField,

  // All Projects Integration Reducers
  setAllProjectsIntegrationLoading,
  setAllProjectsIntegrationData,
  resetAllProjectsIntegration,

  // Create Deposit Reducers
  setCreateDepositLoading,
  setCreateDepositData,
  setCreateDepositError,
  resetCreateDeposit,

  // PrePurchase Reducers
  setPrePurchaseLoading,
  setPrePurchaseSuccess,
  setPrePurchaseOrderId,
  setPrePurchaseError,
  resetPrePurchase,
  setFinalUnitPrice,
} = integrationSlice.actions
